import React from 'react';

import { Card, CardContent, Grid } from '@mui/material';

import { FileResponseInfoFragment } from 'src/api';
import { Button, PdfRenderer } from 'src/components/common';
import { SxProp } from 'src/types/mui';

interface TestVerificationRequestCreateModalFormProps {
  closeModal: () => void;
  generatedReport: FileResponseInfoFragment | undefined;
}

export const TestVerificationRequestPdfPreviewModalForm: React.FC<
  TestVerificationRequestCreateModalFormProps
> = ({ closeModal, generatedReport }) => {
  return (
    <React.Fragment>
      <Card variant="outlined" sx={{ height: 'inherit' }}>
        <CardContent sx={cardContentStyles}>
          <PdfRenderer
            src={generatedReport?.downloadUrl || undefined}
            containerStyles={pdfRendererContainerStyles}
          />
        </CardContent>
      </Card>
      <Grid display="flex" justifyContent="center" mt={2}>
        <Button variant="outlined" onClick={closeModal}>
          Close
        </Button>
      </Grid>
    </React.Fragment>
  );
};

const pdfRendererContainerStyles: SxProp = { border: 'none', height: 'inherit' };
const cardContentStyles = {
  padding: 0,
  '&:last-child': {
    paddingBottom: 0,
  },
};
